import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgNotes = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <g>
      <path
        fill={_.color}
        fillRule="evenodd"
        d="M3 1.5h10a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5M1 2a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm3.75 2a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5zM4 7.75A.75.75 0 0 1 4.75 7h6.5a.75.75 0 0 1 0 1.5h-6.5A.75.75 0 0 1 4 7.75M4.75 10a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
const ForwardRef = forwardRef(SvgNotes);
export default ForwardRef;
